import React, {useState, useEffect, useRef} from 'react'
import { Alert, Button, Col, Row, ListGroup, ListGroupItem, Card, CardBody, CardHeader } from 'reactstrap'
import {
Nav,
Navbar,
NavbarBrand,
NavbarText,
NavbarToggler as NavbarTogglerBase,
NavItem,
NavLink
} from 'reactstrap'
import { purchaseMachine } from 'containers/purchase/purchase_machine'
import PriceSummary from 'components/price_summary'
import { useMachine } from '@xstate/react'
import productMachineConfig from 'containers/purchase/machines/product_machine_config'
import {stepConfig, isLastStep, currentStep, stepStatus} from 'utils/step_utils'
import PurchaseWizard from 'containers/purchase/purchase_wizard'
import ProductHeader from 'containers/purchase/partials/product_header'
import PurchaseWrapper from 'ui/purchase_wrapper'
import useLayout from 'utils/hooks/use_layout'
import { useTranslation } from 'react-i18next'
import stopSales from 'img/stop-sales'
import {isMobile, isMobileOnly} from 'react-device-detect'
import cn from 'classnames'
import Page from 'ui/page'
import Modal from 'ui/modal'
import parse from 'react-html-parser'
import SummaryModal from 'containers/purchase/partials/summary_modal'
import styled from 'styled-components'
import ProductMasonry from './product_masonry'
import Features from 'containers/list/info_types/product_details/features'
import StartingPoint from 'containers/list/info_types/product_details/starting_point'
import {scrollIntoView} from 'scroll-js'
import goforajourneyLogo from 'goforajourney/img/goforajourney-logo-h'
import Rating from 'ui/rating'
import resCn from 'lib/responsive_classes'

const InfoMenuStyles = styled.div.attrs({
  className: ''
})`
  nav.navbar, .product-info-pills {
    li.nav-item:hover {
      background : none;
    }

    li.nav-item > a.nav-link {
      color: var(--bs-dark) !important;

      &:hover {
        background: var(--bs-gray-300) !important;
      }
    }
  }
`

const PageStyles = styled.div.attrs({
  className: ''
})`
  margin-bottom: 200px;

  h2 {
    font-size: 1.5em;
    font-weight: bold;
    margin-bottom: 1em;
  }

  ul {
    margin: 0;
  }

  .product-info {
    font-size: 1.15em;
  }
`

const ProductTitle = styled.h1.attrs({
  className: 'fw-bold'
})`
  font-size: 2em;
`

const ProductBreadcrumb = styled.div.attrs({
  className: 'mb-2'
})`
  font-weight: 500;
  font-size: 1em;
`

const BreadcrumbArrow = () => {
  return (
    <span className="text-primary">></span>
  )
}

const scrollToSection = (ref, offset = 0) => {
  if (ref?.current) {
    const elementTop = ref.current.getBoundingClientRect().top + window.pageYOffset;
    const targetPosition = elementTop - offset;

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  }
}

const ProductHeaderB2c = (props) => {
  const {product, product_info, endpoints, menu_props} = props
  const {destination} = menu_props
  const {title} = product
  const {name} = destination
  const {rating} = product_info

  return (
    <div className="mb-4">
      <ProductTitle>
        {title}
      </ProductTitle>
      <ProductBreadcrumb>
        <a href={endpoints.home}>Home</a> <BreadcrumbArrow/> <a href={endpoints.products}>{name}</a> <BreadcrumbArrow/> {title}
      </ProductBreadcrumb>
      <Rating value={rating}/>
    </div>
  )
}

const ProductPurchase = (props) => {
  const {product_id, endpoints, product, product_info, related_products, cart_params, resSize = "slim"} = props
  const [notificationModal, setNotificationModal] = useState(true)
  const [cartModal, setCartModal] = useState(false)
  const toggleNotificationModal = () => setNotificationModal(!notificationModal)
  const [isFixed, setIsFixed] = useState(false);
  const descriptionRef = useRef()
  const detailsRef = useRef()
  const returnPolicyRef = useRef()
  const locationRef = useRef()

  const scrollToPurchase = () => scrollToSection(purchaseRef)

  const InfoMenu = () => {
    return (
      <Nav
        pills
        className="fw-bold text-primary product-info-pills"
      >
        <NavItem>
          <NavLink href="#" onClick={() => scrollToSection(detailsRef)} className="bg-light text-dark py-1 me-2">
            {i18n.t('product_info.details_title')}
          </NavLink>
        </NavItem>

        {starting_point && (
          <NavItem>
            <NavLink href="#" onClick={() => scrollToSection(locationRef, 105)} className="bg-light text-dark py-1 me-2">
              {starting_point.location_point_type === 'meeting_point' &&
                i18n.t('product_info.meeting_point_title')}
              {starting_point.location_point_type === 'hotel_pickup' &&
                i18n.t('product_info.hotel_pickup_title')}
              {starting_point.location_point_type === 'venue' &&
                i18n.t('product_info.venue_title')}
            </NavLink>
          </NavItem>
        )}

        <NavItem>
          <NavLink href="#" onClick={() => scrollToSection(descriptionRef, 105)} className="bg-light text-dark py-1 me-2">
            {i18n.t('product_info.description_title')}
          </NavLink>
        </NavItem>

        <NavItem>
          <NavLink href="#" onClick={() => scrollToSection(returnPolicyRef, 105)} className="bg-light text-dark py-1 me-2">
            {i18n.t('product_info.return_policy_title')}
          </NavLink>
        </NavItem>
      </Nav>
    )
  }

  const StickyBar = (props) => {
    const {location = 'top', onClickButton, isFixed, product, product_info, className, menu_props} = props
    const {featured_price_label} = product
    const {title} = product_info
    const {root, user} = menu_props

    return (

        <nav
          className={cn([`flex-column navbar navbar-expand-lg navbar-light shadow-lg ${location == 'top' ? "fixed-top" : "fixed-bottom"}`], className)}
          style={{background: 'white'}}
        >
          <div className="container">
            <div className="d-flex justify-content-between align-items-center w-100 pt-2 pb-1">
              {!isMobile &&
                <div className="d-flex flex-column w-100">
                  <div className="d-flex flex-row mb-3">
                    <div className='d-flex align-self-center fw-semibold text-primary' style={{fontSize: '1.45em'}}>{title}</div>
                  </div>
                    <InfoMenuStyles>
                      <InfoMenu/>
                    </InfoMenuStyles>
                </div>
              }
              <div className="d-flex w-100 flex-row justify-content-center justify-content-md-end align-items-center">
                <div className="me-5 me-md-3 fw-bold text-center" style={{fontSize: isMobile ? '1.1em' : '1.5em'}}>
                  {featured_price_label ? i18n.t('product_purchase.featured_price_label', {price: featured_price_label}) : i18n.t('format:actions.book_now')}
                </div>
                {isMobile &&
                  <div>
                    <Button
                      size="md"
                      color="primary"
                      className="shadow rounded-4 px-3 py-3 d-flex justify-content-center align-items-center"
                      style={{fontWeight: '500'}}
                      onClick={() => onClickButton()}
                    >
                      <i style={{fontSize: '1.35em'}} className="far fa-calendar-alt me-2 pe-1"/> {i18n.t('format:actions.check_availability')}
                    </Button>
                  </div>
                }
              </div>
            </div>
          </div>
        </nav>

    )
  }

  const StickyHeader = (props) => {
    const ref = useRef(null)

    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (isMobile) {
            const isAbove = entry.boundingClientRect.top >= 0 && !entry.isIntersecting
            setIsFixed(isAbove)
          } else {
            setIsFixed(entry.boundingClientRect.top < 0 && !entry.isIntersecting)
          }
        },
        { threshold: 0 }
      );

      if (ref.current) observer.observe(ref.current);

      return () => observer.disconnect();
    }, []);

    return (
      <div>
        <div ref={ref} style={{ height: "1px", background: "transparent" }} className="text-center"/>

        {isFixed &&
          <StickyBar location={isMobile ? 'bottom' : 'top'} {...props} isFixed={isFixed} onClickButton={() => scrollToPurchase()}/>
        }
      </div>
    )
  }

  const {i18n} = useTranslation()
  const config = productMachineConfig(props.machine, props)
  const stepsConfig = config.steps

  const machine = useMachine(purchaseMachine(config), {
    context: {
      endpoints: endpoints,
      product_id: product_id,
      timezone: product.local_timezone,
      currency: product.currency,
      related_products: related_products
    }
  })

  const mode = useLayout()

  const [current, send] = machine
  const {reservation_ready, cart, redirect_url} = current.context

  useEffect(() => {
    if (current.value == 'reserved') {
      if (cart_params.enable_cart) {
        setCartModal(true)
      } else {
        document.location.href = redirect_url
      }
    }
  }, [current.value])

  const currentStepConfig = stepConfig(stepsConfig, current.value)

  const {error} = current.context
  const {product_status, title, notification, notification_type} = props.product

  const PurchaseError = ({error}) => (
    <div id="purchase-error">
      {error &&
        <Alert color="danger">{error}</Alert>
      }
    </div>
  )

  const ReservationButton = () => {
    return (
      <Button
        disabled={!reservation_ready}
        color={'danger'}
        className={cn('fw-semibold', 'text-white', 'w-100', 'btn-lg', 'rounded-5')}
        onClick={() => send('RESERVATION_REQUEST')}
      >
        {i18n.t('product_purchase.reservation_button')}
      </Button>
    )
  }

  if (product_status != 'active') {
    return (
      <PurchaseWrapper mode={mode} className="text-center p-3 container">
        <div className="alert alert-warning" role="alert">
          <h2>{title}</h2>
          <p className="m-0">{i18n.t('product_purchase.stop_sales_description')}</p>
          <img src={stopSales} alt="Stop sales"/>
        </div>
      </PurchaseWrapper>
    )
  }

  const {featured_price_label} = product
  const {featured_image, featured_image_srcset, images, images_srcset, short_description, long_description, return_policy_text, starting_point, hooks, highlights} = product_info
  const buttonRef = useRef()
  const purchaseRef = useRef()

  const Highlights = ({highlights}) => {
    const {i18n} = useTranslation()
    const highlightsArray = JSON.parse(highlights)

    if (!highlightsArray || (highlightsArray && highlightsArray.length < 1) ) { return '' }

    return (
      <React.Fragment>
        <h2>{i18n.t('product_info.highlights')}</h2>
        <ul className="m- p-0" style={{listStyleType: 'none'}}>
          {highlightsArray.map((item) =>
            <li className="arrow-left">
              <i className='fas fa-chevron-right text-primary me-1'/> {parse(item)}
            </li>
          )}
        </ul>

      </React.Fragment>
    )
  }

  const Hooks = ({hooks}) => {
    const hooksArray = JSON.parse(hooks)

    if (!hooksArray || (hooksArray && hooksArray.length < 1) ) { return '' }

    return (
      <Row>
        <Col className="mt-3">
          <ul className="m-0 p-3 bg-white border rounded-5 mb-3" style={{listStyle: 'none'}}>
            {hooksArray.map((item) =>
              <li className="p-1 d-flex">
                <div style={{fontSize: '1.3em'}}>
                  <i className='fa fa-check text-primary pe-3'/>
                </div>
                <div style={{fontSize: '1.15em'}}>
                  {parse(item)}
                </div>
              </li>
            )}
          </ul>
        </Col>
      </Row>
    )
  }

  const showReservationButton = !config.hideReservatioButton && isLastStep(stepsConfig, current.value)

  return (
    <React.Fragment>
      <Page {...props}>
        <ProductHeaderB2c {...props}/>
        <ProductMasonry title={title} featured_image={featured_image_srcset} images={images_srcset}/>
        <PageStyles>
          <div ref={detailsRef} className="row mt-4 pt-4">
            <Col xs="12" md="8" className="product-info pt-3">
              {!isMobile &&
                <Row className="pb-3">
                  <Col>
                    <InfoMenuStyles>
                      <InfoMenu/>
                    </InfoMenuStyles>
                  </Col>
                </Row>
              }

              <Row className="pt-4">
                <Col>
                  <p>
                    {parse(short_description)}
                  </p>
                </Col>
              </Row>
              <div className="row">
                <Col>
                  <Highlights highlights={highlights}/>
                </Col>
              </div>

              <Row className="pt-4">
                <Col>
                  <Features {...product_info}/>
                </Col>
              </Row>
              {starting_point &&
                <div ref={locationRef} className="row pt-4">
                  <Col>
                    <StartingPoint {...starting_point}/>
                  </Col>
                </div>
              }
              <div ref={descriptionRef} className="row pt-4">
                <Col>
                  <h2>{i18n.t('product_info.description_title')}</h2>
                  <p>
                    {parse(long_description)}
                  </p>
                </Col>
              </div>
              <div ref={returnPolicyRef} className="row pt-4">
                <Col>
                  <h2>
                    {i18n.t('product_info.return_policy_title')}
                  </h2>
                  <p className="policy-text">{parse(return_policy_text)}</p>
                </Col>
              </div>
            </Col>
            <Col xs="12" md="4">
              <h2
                className={resCn({
                  wide: 'text-md-start',
                  slim: 'text-start text-md-center mt-3 mt-md-0',
                  all: 'mb-2'
                }, resSize)}
                style={{fontSize: '1.7em'}}
              >
                {featured_price_label ? i18n.t('product_purchase.featured_price_label', {price: featured_price_label}) : i18n.t('format:actions.book_now')}
              </h2>
              <Hooks hooks={hooks}/>

              {!isMobile &&
                <StickyHeader {...props}/>
              }

              <div className='sticky-top' style={{zIndex: 1, paddingTop: isFixed && !isMobile ? '120px' : '0px'}}>

              <div ref={purchaseRef} className="mb-3"/>

              <PurchaseError error={error}/>

                {Object.keys(stepsConfig).map((step) => {
                  const Module = stepsConfig[step].component
                  const moduleStatus = stepStatus(stepsConfig, step, currentStep(current.value))

                  return (
                    <Module
                      key={step}
                      config={props}
                      machine={machine}
                      status={moduleStatus}
                      isLastStep={isLastStep(stepsConfig, current.value)}
                      stepConfig={currentStepConfig}
                      resSize={resSize}
                      {...stepsConfig[step].componentProps}
                    />
                  )
                })}

                <Row>
                  <Col
                    xs="12"
                    md={resSize == 'slim' ? "12" : "4"}
                    className={resCn({
                      wide: showReservationButton ? "offset-md-6" : "offset-md-8",
                      slim: "offset-0"
                    }, resSize)}
                  >
                    <PriceSummary machine={machine}/>
                  </Col>
                  {showReservationButton &&
                    <Col
                      xs="12"
                      md={resSize == 'slim' ? "12" : "2"}
                      className={resCn({
                        wide: "mt-md-0",
                        slim: "mt-3"
                      }, resSize)}
                    >
                      <ReservationButton/>
                    </Col>
                  }
                </Row>
              </div>

              {isMobile &&
                <StickyHeader {...props}/>
              }

            </Col>
          </div>
        </PageStyles>
      </Page>
    </React.Fragment>
  )
}

export default ProductPurchase
